import React, { forwardRef, PropsWithChildren } from 'react'
import { makeStyles } from '@material-ui/core'
import { IconButton, Typography } from 'foundations-library/components'
import { useHistory } from 'react-router-dom'

const jss = (theme) => {
    const { colors } = theme['foundations-library']
    return {
        pageHeader: {
            display: 'flex',
            backgroundColor: colors.neutral[50],
            height: '54px',
            alignItems: 'center',
            paddingLeft: '10px',
            width: '100%'
        },
        goBack: {
            borderRight: `1px solid ${colors.neutral[100]}`,
            marginRight: 10
        }
    }
}

const useStyles = makeStyles(jss)

interface PropsInterface {
    onClickBack?(): unknown
    withGoBack?: boolean,
}

/**
 *
 */
const PageHeader = forwardRef<HTMLDivElement, PropsWithChildren<PropsInterface>>(({
    onClickBack,
    withGoBack,
    children
}, ref): JSX.Element => {
    const styles = useStyles()
    const history = useHistory()

    const onClickButton = () => {
        if (onClickBack) {
            onClickBack()
        } else if (withGoBack) {
            history.go(-1)
        }
    }

    return <div ref={ref} className={styles.pageHeader} data-testid='page-header'>
        { (onClickBack || withGoBack) && <div className={styles.goBack}>
            <IconButton
                onClick={onClickButton}
                name='back'
                variant='icon'
                color='neutral'
                data-testid='page-header-back-button'
            />
        </div> }
        <Typography variant='h8' color='neutral-900' data-testid='page-header-children'>
            {children}
        </Typography>
    </div>
})

PageHeader.displayName = 'PageHeader'

export default PageHeader
